import axios from 'axios';

const updateLotLocations = function (target) {
  const row = $(target).parents('tr');
  const productLotId = row
    .find('.transfer-product-lot-select option:selected')
    .val();

  if (productLotId !== '') {
    axios
      .get('/locations_by_product_lot', {
        params: { product_lot_id: productLotId },
      })
      .then(response => {
        const select = row.find('.transfer-product-origin-location-select');
        select.empty();
        $.each(response.data, function (_, location) {
          select.append(
            $('<option>', {
              text: location.warehouse_path,
              value: location.id,
            })
          );
        });
        select.trigger('change');
      })
      .catch(error => {
        console.log(error.response.data);
      });
  }
};

const updateLotMeasurementUnit = function (target) {
  const row = $(target).parents('tr');
  const productLotId = row
    .find('.transfer-product-lot-select option:selected')
    .val();

  if (productLotId !== '') {
    axios
      .get('/product_lot_measurement_unit', {
        params: { product_lot_id: productLotId },
      })
      .then(response => {
        const lotUnitName = row.find('.stock-transfer-product-unit');
        lotUnitName.text(response.data.name);
      })
      .catch(error => {
        console.log(error.response.data);
      });
  }
};

const updateLotLocationStock = function (target) {
  const row = $(target).parents('tr');
  const productLotId = row
    .find('.transfer-product-lot-select option:selected')
    .val();
  const locationId = row
    .find('.transfer-product-origin-location-select option:selected')
    .val();
  if (productLotId !== '' && locationId !== '') {
    axios
      .get('/product_lot_location_stock', {
        params: { product_lot_id: productLotId, location_id: locationId },
      })
      .then(response => {
        const lotStock = row.find('.stock-transfer-product-stock');
        lotStock.text((+response.data.stock).toFixed(2));
      })
      .catch(error => {
        console.log(error.response.data);
      });
  }
};

document.addEventListener('turbolinks:load', function () {
  $(
    '.transfer-origin-warehouse-select, .transfer-destination-warehouse-select'
  ).select2({
    placeholder: 'Seleccione un almacén...',
  });

  $('#transfer-products-fields').on(
    'cocoon:after-insert',
    function (e, addedProduct) {
      const lotSelect = addedProduct.find('.transfer-product-lot-select');
      const locationSelect = addedProduct.find(
        '.transfer-product-origin-location-select'
      );
      lotSelect.select2({
        placeholder: 'Buscar un producto (código de lote o nombre)',
        minimumInputLength: 3,
        width: '100%',
      });
      locationSelect.select2({
        width: '100%',
      });

      axios
        .get('/product_lots_by_warehouse', {
          params: {
            warehouse_ids: $('.transfer-origin-warehouse-select').val(),
          },
        })
        .then(response => {
          lotSelect.find('option').not(':first').remove();
          $.each(response.data, function (_, lot) {
            lotSelect.append(
              $('<option>', {
                text: lot.code_and_product,
                value: lot.id,
              })
            );
          });
          lotSelect.trigger('change');
        })
        .catch(error => {
          console.log(error.response.data);
        });

      $('.transfer-origin-warehouse-select').on('change', function () {
        $('#transfer-products-fields > tr').each(function (index, tr) {
          axios
            .get('/product_lots_by_warehouse', {
              params: {
                warehouse_ids: $('.transfer-origin-warehouse-select').val(),
              },
            })
            .then(response => {
              const row = $(tr);
              const lotSelectBox = row.find('.transfer-product-lot-select');
              lotSelectBox.find('option').not(':first').remove();
              $.each(response.data, function (_, lot) {
                lotSelectBox.append(
                  $('<option>', {
                    text: lot.code_and_product,
                    value: lot.id,
                  })
                );
              });
              lotSelectBox.trigger('change');
            })
            .catch(error => {
              console.log(error.response.data);
            });
        });
      });

      $('.transfer-product-lot-select').on('change', function () {
        updateLotLocations($(this));
        updateLotLocationStock($(this));
        updateLotMeasurementUnit($(this));
      });
      $('.transfer-product-origin-location-select').on('change', function () {
        updateLotLocationStock($(this));
      });
    }
  );
  $('.transfer-product-lot-select').on('change', function () {
    updateLotLocations($(this));
    updateLotLocationStock($(this));
    updateLotMeasurementUnit($(this));
  });
  $('.transfer-product-origin-location-select').on('change', function () {
    updateLotLocationStock($(this));
  });
});
